import React from 'react'
import Row from '../Row'
import { ColOptions, ColSelect } from '../Col'
import Dropdown from '../../Dropdown'
import Button, { ButtonIcon } from '../../Button/Button'
import styles from '../../../../CSS/main.css'
import classNames from 'classnames'

export type BaseProps = {
  readonly onSelected?: () => void
  readonly selected?: boolean
  readonly options?: JSX.Element
  readonly onClick?: () => void
  readonly forbiddenCount?: number
  readonly showMore?: boolean
  readonly isCommentList?: boolean
}

const ListItem: React.FC<BaseProps> = ({
  children,
  onSelected,
  selected,
  options,
  onClick,
  showMore,
  isCommentList,
}) => {
  return (
    <Row showMore={showMore} isCommentList={isCommentList} onClick={onClick}>
      {Boolean(onSelected) && (
        <ColSelect onChange={onSelected} toggle={selected} />
      )}
      {children}
      <ColOptions>
        {!!options && (
          <Dropdown
            trigger={<ButtonIcon additionalClassNames={[styles.IconOptions]} />}
            position={'bottom'}>
            {options}
          </Dropdown>
        )}
      </ColOptions>
    </Row>
  )
}

export default ListItem
